import React, { useState } from "react";
import { useFormik } from "formik";
import { message } from "antd";
import Loader from "../Loader/Loader";
import * as Yup from "yup";
import JsonToImage from "../JsonToImage";
import PreviewJsonFormat from "../Voucher/PreviewJsonFormat";
import { editLayout } from "../../Web Apis/Apis";
import Avtar from "../../Images/no image.png";

function EditLayout({
  showModal,
  setShowModal,
  action,
  setAction,
  selectedItem,
}) {
  const [loading, setLoading] = useState(false);
  const [showJsonModal, setShowJsonModal] = useState(false);
  const [showFormatModal, setShowFormatModal] = useState(false);
  const [image, setImage] = useState(selectedItem.previewImage);

  const closeCreateModal = () => {
    setShowModal(false);
  };

  const handleJsonModal = () => {
    if (formik.values.templateJson === "" || !formik.values.templateJson) {
      message.error("Please provide valid json format");
      return;
    }

    try {
      const parsedJson = JSON.parse(formik.values.templateJson);
      if (
        !parsedJson ||
        typeof parsedJson !== "object" ||
        !parsedJson.editableFields
      ) {
        message.error("Invalid JSON structure. 'editableFields' missing.");
        return;
      }
      setShowJsonModal(true);
    } catch (error) {
      message.error("Invalid JSON format");
      return;
    }
  };

  const handlePreviewFormat = () => {
    setShowFormatModal(true);
  };

  const handleImageChange = async (file) => {
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      formik.setFieldValue("previewImage", file);
    }
  };

  const formatJson = {
    id: 1744606153986,
    title: "hhhhh second",
    imageUrl: "",

    editableFields: {
      background: {
        type: "color",
        value: "#FFFDD0",
        editable: true,
      },

      image_0: {
        type: "image",
        filePath:
          "https://fetch-delivery.s3.amazonaws.com/kaza-house-swap/1746771458006-Image.png",
        position: {
          x: "55%",
          y: "20%",
        },
        size: {
          width: "100px",
          height: "100px",
        },
        scale: 1.0351834945646925,
        rotation: 0.0,
        offset: { x: 0.0, y: 0.0 },
        editable: true,
      },

      image_1: {
        type: "image",
        filePath:
          "https://fetch-delivery.s3.amazonaws.com/kaza-house-swap/1746771458006-Image.png",
        position: {
          x: "15%",
          y: "20%",
        },
        size: {
          width: "100px",
          height: "100px",
        },
        scale: 1.0731454474202733,
        rotation: 0.0,
        offset: { x: 0.0, y: 0.0 },
        editable: true,
      },

      text_0: {
        type: "text",
        text: "Title",
        font: "Hammersmith One",
        fontSize: "28px",
        textAlign: "center",
        size: {
          width: "100%",
          height: "auto",
        },
        color: "#4a0d26",
        position: {
          x: "0%",
          y: "5%",
        },
        scale: 1.0,
        rotation: 0.0,
        isBold: false,
        isItalic: false,
        isUnderline: false,
        editable: true,
      },

      text_1: {
        type: "text",
        text: "Promise",
        font: "Agbalumo",
        fontSize: "20px",
        textAlign: "center",
        size: {
          width: "100%",
          height: "auto",
        },
        color: "#4a0d26",
        position: {
          x: "0%",
          y: "75%",
        },
        scale: 1.0,
        rotation: 0.0,
        isBold: false,
        isItalic: false,
        isUnderline: false,
        editable: true,
      },
    },
  };

  const formik = useFormik({
    initialValues: {
      title: selectedItem.draftVoucherName,
      templateJson: JSON.stringify(selectedItem.template, null, 2),
      previewImage: selectedItem.previewImage || null,
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Title is required")
        .trim("title should not have spaces"),
      templateJson: Yup.string().required("Json is required"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        setLoading(true);

        const response = await editLayout(selectedItem.id, { ...values });
        if (response?.data?.success) {
          message.success(response?.data?.message);
          resetForm();
          setShowModal(false);
          setAction(!action);
        }
      } catch (error) {
        console.log("Error while create layout", error);
        message.error(
          error?.response?.data?.message || "Error while create layout"
        );
      } finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white  rounded-2xl shadow-lg w-[600px] h-[700px] overflow-y-auto">
        <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
          Create Default Layout
        </h3>

        <form onSubmit={formik.handleSubmit} className="p-8">
          <div className="w-full">
            <label className="block mb-2 mt-2 text-xl font-bold">
              Layout Title
            </label>
            <input
              type="text"
              name="title"
              className="border border-gray-800 p-2 w-full "
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.title}
              placeholder="Enter title of the layout"
            />
            {formik.errors.title && (
              <p className="text-red-600 mt-1">{formik.errors.title}</p>
            )}
          </div>

          <div className="w-full">
            <label className="block mb-2 mt-4 text-xl font-bold">
              Layout Json
            </label>
            <textarea
              name="templateJson"
              rows={8}
              className="border border-gray-800 p-2 w-full "
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.templateJson}
              placeholder="Enter json of the layout"
            />
            {formik.errors.templateJson && (
              <p className="text-red-600 ">{formik.errors.templateJson}</p>
            )}
          </div>

          <div className="flex gap-2">
            <button
              onClick={handleJsonModal}
              type="button"
              className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
            >
              Preview Layout
            </button>

            <button
              onClick={handlePreviewFormat}
              type="button"
              className="bg-orange-300 text-black w-52 py-2 px-4 rounded-md hover:bg-orange-400 transition duration-200"
            >
              Preview Json Format
            </button>
          </div>

          <div className="mt-2 relative w-52 h-48">
            <label className="block mb-2 mt-4 text-xl font-bold">
              Preview Image
            </label>
            <img
              src={image || Avtar}
              alt="Profile Preview"
              // ref={fileInputRef}
              className="border border-gray-800 w-full h-full object-cover"
            />
          </div>

          <div className="flex justify-end p-4 mt-8 border-t gap-6">
            <button
              onClick={closeCreateModal}
              className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
            >
              {formik.isSubmitting ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
        {loading && <Loader />}
      </div>

      {showJsonModal && (
        <JsonToImage
          json={JSON.parse(formik.values.templateJson)}
          setShowModal={setShowJsonModal}
          handleImageChange={(file) => handleImageChange(file)}
        />
      )}

      {showFormatModal && (
        <PreviewJsonFormat
          formatJson={JSON.stringify(formatJson, null, 2)}
          setShowModal={setShowFormatModal}
        />
      )}
    </div>
  );
}

export default EditLayout;
